<template>
  <div class="chat-message __container">
    <div>
      <p class="chat-message __content">
        <span class="chat-message __avatar" v-if="isAudience">
          {{ user.avatar }}
        </span>
        <span class="chat-message __presenter-avatar" v-else>
          <aha-avatar
            :name="user.name"
            :image="user.avatar"
            :id="user.id"
            :width="18"
            :height="18"
            class="chat-message __presenter-avatar-icon"
          />
        </span>
        <span
          class="chat-message __name"
          :class="{ '__presenter-name': isPresenter }"
        >
          <aha-profanity-filter
            :text="userName"
            :filtering-profanity="filteringProfanity"
            :style="{ color: user.color }"
          />
        </span>
        <span v-if="isPresenter" class="chat-message __user-type">
          <aha-icon name="presenter" class="__user-type-icon" />
        </span>

        <span class="chat-message __message">
          <aha-profanity-filter
            v-if="isTextMessage"
            :text="message"
            :filtering-profanity="filteringProfanity"
          />
          <span v-else class="chat-message __status-update">{{
            $t(message)
          }}</span>
        </span>
        <span
          v-if="!received"
          v-tooltip="'Your message failed to deliver. Click to retry.'"
          class="chat-message __error"
          @click="retry(message)"
        >
          <aha-icon name="information" />
        </span>
        <span class="chat-message __timestamp">
          {{ filterTimestamp(timestamp) }}
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import AhaProfanityFilter from '../../../utils/profanity-filter/ProfanityFilter.vue'

export default {
  components: {
    AhaProfanityFilter,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: () => ({
        name: '',
        avatar: '',
        color: '',
      }),
    },
    timestamp: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    received: {
      type: Boolean,
      default: true,
    },
    filteringProfanity: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userName() {
      let finalName = ''
      let insideBracket = ''
      const { name, teamName, isSelf } = this.user
      if (isSelf && teamName) {
        insideBracket = `${this.$t('you')} - ${teamName}`
      } else if (teamName) {
        insideBracket = `${teamName}`
      } else if (isSelf) {
        insideBracket = this.$t('you')
      }
      if (insideBracket) {
        finalName = `${name} (${insideBracket})`
      } else {
        finalName = `${name}`
      }
      return finalName
    },
    isAudience() {
      return this.user.type === 'audience'
    },
    isPresenter() {
      return this.user.type === 'presenter'
    },
    isTextMessage() {
      return this.type === 'text'
    },
  },

  methods: {
    filterTimestamp(value) {
      const isToday = moment().isSame(new Date(value), 'day')
      const valueToLocale = moment(new Date(value)).locale('en')
      if (isToday) {
        return valueToLocale.format('hh:mm A')
      }
      return valueToLocale.format('DD-MM-YYYY hh:mm A')
    },
    retry(message) {
      this.$emit('retrySendingMessage', message)
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-message {
  &.__container {
    margin-bottom: 6px;
    word-break: break-word;
  }

  &.__content {
    font-size: 14px;
    text-align: left;
    margin: 0;
    cursor: pointer;
    &:hover .__timestamp {
      display: inline-block;
    }
  }

  &.__user {
    display: inline-flex;
    align-items: center;
  }

  &.__avatar {
    width: 22px;
    text-align: center;
    border-radius: 100%;
    margin-right: 4px;
  }

  &.__presenter-avatar {
    border-radius: 100%;
    margin-right: 4px;
    width: 22px;
    .__presenter-avatar-icon {
      display: inline-block;
      margin-bottom: -3px;
      font-size: 10px;
    }
    &::v-deep .aha-avatar__image {
      img {
        max-width: 100%;
      }
    }
  }

  &.__name {
    margin-right: 6px;
    font-weight: bold;
    &.__presenter-name {
      margin-right: 0;
    }
  }

  &.__user-type {
    color: #999999;
    font-size: 10px;
    margin-right: 6px;
  }

  &.__message-container {
    text-align: left;
    background: #eee;
    border-radius: 3px;
    padding: 6px;
  }

  &.__message {
    line-height: 1.5;
    margin-right: 8px;
  }

  &.__status-update {
    color: #999;
    margin-left: -6px;
  }

  &.__timestamp {
    font-size: 12px;
    transition: opacity 0.2s ease;
    color: #afafaf;
    display: none;
  }

  &.__error {
    margin-right: 8px;
    color: #ff4954;
    vertical-align: middle;
  }

  &.__status-update {
    color: #aaa;
    padding: 12px 6px;
    text-align: center;
  }
}
</style>
